import { IconRefresh } from "@tabler/icons";
import { useTheme } from "styled-components";

import { useGetApiAccountsQuery } from "@sso/apis/apiAccounts/hooks";
import { TableHeader } from "@sso/components/TableHeader";
import { TableLayoutWrapper } from "@sso/components/TableLayoutWrapper";
import { TablePagination } from "@sso/components/TablePagination";
import { TableProvider, TableProviderState } from "@sso/context/tableContext";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectAPIAccountPagination, selectApiKeysTableStatus } from "@sso/store/slices/apiAccount";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";

import { APIAccountKeysTable } from "./APIAccountKeysTable";
import { APIAccountsTable } from "./APIAccountsTable";
import { apiAccountsTableColumns } from "./APIAccountsTableColumns";

export const APIAccounts = () => {
  const theme = useTheme();
  const { data, error } = useGetApiAccountsQuery();
  const projectPagination = useAppSelector(selectAPIAccountPagination);
  const showApiKeysTable = useAppSelector(selectApiKeysTableStatus);

  const tableContextInstance: TableProviderState = { ...projectPagination, columns: apiAccountsTableColumns };

  const TableActions = (
    <Flex>
      <IconButton title="Refresh">
        <IconRefresh />
      </IconButton>
    </Flex>
  );

  return (
    <>
      {false && <CircleLoading color={theme.colors.secondary.dark} size={8} blurBackground />}
      <TableProvider tableInstance={tableContextInstance}>
        <TableHeader title="API Accounts" TableActions={TableActions} />
        <TableLayoutWrapper error={error} data={data}>
          {data && <APIAccountsTable apiAccountList={data.resources} columns={apiAccountsTableColumns} />}
        </TableLayoutWrapper>
        <TablePagination totalPages={data?.totalPages} />
      </TableProvider>
      {showApiKeysTable && <APIAccountKeysTable />}
    </>
  );
};
